<template>
  <div class="base-class" :class="['base-cell']" tabindex="0">
    <i size="1.4rem" :class="['mdi', 'mr-2', params.icon]" />
    <span :class="['main-value', mainValueColourClass]">{{ formattedDisplayValue }}</span>
    <span :class="['secondary-value', secondaryValueColourClass]">
      {{ formattedSecondaryValue }}
    </span>
  </div>
</template>

<script>
import { isNil, isNaN } from 'lodash';
import Vue from 'vue';
import numberFormats from '@enums/number-formats';

export default Vue.extend({
  computed: {
    formattedDisplayValue() {
      return !isNil(this.params.value) ? `${this.valueFormatter(this.params.value)}` : '-';
    },

    formattedSecondaryValue() {
      return !isNil(this.params.secondaryValue) && this.params.secondaryValue !== 0
        ? `${this.secondaryValuePrefix}${this.valueFormatter(this.params.secondaryValue)}`
        : '';
    },

    secondaryValuePrefix() {
      return this.params.secondaryValue > 0 ? '+' : '';
    },

    mainValueColourClass() {
      if (!this.params.isDeltasGrid || this.params.value === 0) {
        return '';
      }
      return this.params.value > 0 ? 'colour-green' : 'colour-red';
    },

    secondaryValueColourClass() {
      return this.params.secondaryValue > 0 ? 'colour-green' : 'colour-red';
    },
  },
  methods: {
    valueFormatter(value) {
      if (isNaN(value)) {
        return value;
      }

      if (isNil(value)) {
        return;
      }

      if (value === 0) {
        return '0%'; // To avoid having 0,0% when showing a percentage with 1 decimal place
      }

      return this.formatNumber({
        number: this.formatEngineInput(value),
        format: this.params.format || numberFormats.percent,
        nullAsDash: true,
      });
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';
.base-class {
  display: flex;
  align-items: center;
}

.base-cell {
  width: 100%;
  height: 100%;
  margin-left: -5px;
}

.main-value {
  font-size: 1.4rem;
  margin-right: 5px;
}

.secondary-value {
  font-size: 1.1rem;
}

.mdi {
  width: 1.2rem;
}
</style>
